import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'serviceRateDealers': [],
  'serviceRate': null,
  'loadingUrl': false,
  'urlFile': '',
};


export const serviceRate = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SERVICE_RATE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SERVICE_RATE]: (state, action) => ({
      ...state,
      'serviceRate': action.response.data || {},
      'serviceRateDealers': action.response.data.dealers || [],
      'loading': false,
    }),
    [ActionTypes.FETCHED_SERVICE_RATE_FAILED]: (state, action) => ({
      ...state,
      'serviceRate': {},
      'serviceRateDealers': [],
      'loading': false,
    }),
    [ActionTypes.DOWNLOADING_SERVICE_RATE_FILE]: () => ({
      ...state,
      'loadingUrl': true,
    }),
    [ActionTypes.DOWNLOADED_SERVICE_RATE_FILE]: () => ({
      ...state,
      'loadingUrl': false,
      'urlFile': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_SERVICE_RATE_FILE_FAILED]: () => ({
      ...state,
      'loadingUrl': false,
      'urlFile': '',
    }),
    [ActionTypes.DELETE_URL_SERVICE_RATE]: (state, action) => ({
      ...state,
      'urlFile': '',
    }),
    [ActionTypes.DELETE_SERVICE_RATE]: () => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
